import {
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  Input,
  Text,
  VStack,
  Box,
  Image,
} from "@chakra-ui/react";
import { LoginBrandingLogo, LoginBrandingTitle } from "@root/components/branding";
import {
  LinkText,
  //StyledCheckboxText,
  //StyledInputField,
  AuthFormContainer,
  AuthCardEllipse,
  AuthCardTopFrame,
  KpecLogoText,
  AuthHeading,
  AuthSubheading,
  AuthFieldsWrapper,
  AuthInputBox,
  AuthInputField,
  AuthLabelText,
  AuthButton,
  AuthButtonWrapper,
  AuthLinkText,
  AuthCheckboxText,
  AddNoticeButton,
} from "@root/commonStyles/commonStyle";
//import { PasswordInput } from "@root/components/common/passwordInput/passwordInput";
import { ROUTE_NAMES, USER_TYPES } from "@root/constants";
import { adminLogin, login } from "@store/thunks";
import { Field, Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LanguageToggle } from "@root/components/dashboard/sidebar/languagetoggler";
// //import ReCAPTCHA from "react-google-recaptcha";
// import { NounCube } from "@root/assets/images";
// import { StyledAuthLinkOrTextBox } from "./styles";
// import LoginLogo from "@assets/icons/login-logo.svg";
// import { CustomButton } from "@root/components/common/button/customButton";
// import AddNoticeModal from "@root/components/add-notice-modal/AddNoticeModal";

export const AdminLogin: React.FC = () => {
  const { t } = useTranslation("common");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  // const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const initialValues = {
    email: "",
    password: "",
    rememberMe: false,
  };
  const validate = (values: LoginValues) => {
    const errors: Partial<LoginValues> = {};

    if (!values.password) {
      errors.password = t("login.requiredPassword");
    } else if (values.password.length < 6) {
      errors.password = t("login.passwordValidation");
    }
    return errors;
  };
  // Shift Admin here
  const onSuccess = (res: any) => {
    if (!res?.token) {
      return;
    }
    localStorage.setItem("accessTprooken", res.token);
    setLoading(false);
    if (res?.user?.roleId === USER_TYPES.ADMIN || res?.user?.roleId === USER_TYPES.ORGANIZATION_ADMIN) {
      navigate(ROUTE_NAMES.ADMIN_USER_MANAGEMENT);
    } else {
      console.log("Navigating to USER_MANAGEMENT", res?.user?.roleId);
      navigate(ROUTE_NAMES.DASHBOARD);
    }
  };
  const onError = () => {
    setLoading(false);
  };

  const onSubmit = (values: any) => {
    setLoading(true);
    try {
      const payload = {
        password: values.password,
        email: values.email,
        // captcha_token: captchaToken,
      };
      dispatch(
        adminLogin({
          payload,
          onSuccess,
          onError,
        })
      );
    } catch (error) {
      console.log(error);
    }
  };

  // const handleCaptchaChange = (token: string | null) => {
  //   setCaptchaToken(token);
  // };

  return (
    <>
      <Box position="relative" minH="100vh">
        <LanguageToggle variant="public" position="absolute" top="20px" right="20px" />
        <AuthFormContainer>
          <AuthCardEllipse />
          <AuthCardTopFrame>
            <LoginBrandingLogo />
            <LoginBrandingTitle />
          </AuthCardTopFrame>
          <Formik
            validate={validate}
            initialValues={initialValues}
            onSubmit={onSubmit}
          >
            {({ handleSubmit, errors, touched, values, setFieldValue }) => (
              <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                <AuthFieldsWrapper>
                  <Flex
                    direction="column"
                    align="flex-start"
                    gap="1rem"
                    width="100%"
                  >
                    {/* Frame 2.1: ID field */}
                    <Flex
                      direction="column"
                      align="flex-start"
                      gap="0.5rem"
                      width="100%"
                    >
                      <AuthLabelText>{t("login.email")}</AuthLabelText>
                      <FormControl
                        isInvalid={!!errors.email && touched.email}
                        width="100%"
                      >
                        <AuthInputBox>
                          <AuthInputField
                            id="email"
                            name="email"
                            type="email"
                            required
                            placeholder={t("login.enterEmail")}
                            value={values.email}
                            onChange={(e: React.ChangeEvent<any>) =>
                              setFieldValue("email", e.target.value)
                            }
                          />
                        </AuthInputBox>
                        <FormErrorMessage>{errors.email}</FormErrorMessage>
                      </FormControl>
                    </Flex>
                    {/* Frame 2.2: Password field and actions */}
                    <Flex
                      direction="column"
                      align="flex-start"
                      gap="0.5rem"
                      width="100%"
                    >
                      <AuthLabelText>{t("login.password")}</AuthLabelText>
                      <FormControl
                        isInvalid={!!errors.password && touched.password}
                        width="100%"
                      >
                        <AuthInputBox>
                          <AuthInputField
                            id="password"
                            name="password"
                            type="password"
                            required
                            placeholder={t("login.phPassword")}
                            value={values.password}
                            onChange={(e: React.ChangeEvent<any>) =>
                              setFieldValue("password", e.target.value)
                            }
                          />
                        </AuthInputBox>
                        <FormErrorMessage>{errors.password}</FormErrorMessage>
                      </FormControl>
                      {/* Frame 2.2.1: Remember me and Forgot Password */}
                      <Flex justify="space-between" align="center" width="100%">
                        {/* Frame 2.2.1.1: Checkbox and label */}
                        <Flex align="center" gap="0.25rem">
                          <Field
                            colorScheme="purple"
                            as={Checkbox}
                            id="rememberMe"
                            name="rememberMe"
                            width="20px"
                            height="20px"
                          />
                          <AuthCheckboxText>
                            {t("login.remeberMe")}
                          </AuthCheckboxText>
                        </Flex>
                        <AuthLinkText
                          onClick={() => navigate(ROUTE_NAMES.FORGET_PASSWORD)}
                          whiteSpace="nowrap"
                        >
                          {t("login.forgot")}
                        </AuthLinkText>
                      </Flex>
                    </Flex>
                  </Flex>
                </AuthFieldsWrapper>
                {/* Button in its own Flex */}
                <AuthButtonWrapper>
                  <AuthButton isLoading={loading} type="submit">
                    {t("login.signIn")}
                  </AuthButton>
                </AuthButtonWrapper>
              </form>
            )}
          </Formik>

          {!pathname.includes(ROUTE_NAMES.ADMIN_LOGIN) && (
            <Flex
              direction="row"
              align="center"
              justify="center"
              gap="0.25rem"
              width="100%"
            >
              <AuthCheckboxText>{t("login.dontHaveAccount")}</AuthCheckboxText>
              <LinkText to={"/signup"} color={"#40599B"}>
                {t("signup.signupLink")}
              </LinkText>
            </Flex>
          )}
        </AuthFormContainer>
      </Box>
    </>
  );
};
